"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ApptPurposeFilter = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _button = require("@kyruus/button");
var _ApptPurposeFilter = require("./ApptPurposeFilter.styles");
var _constants = require("../../../lib/constants");
const ApptPurposeFilter = _ref => {
  let {
    count,
    total,
    isFiltered,
    nameFilterValue,
    visitTypeFilterValue,
    onNameFilterChange,
    onVisitTypeFilterChange,
    onClearFilters,
    labels: {
      purposeSearchLabel = 'Filter by purpose of visit',
      purposeSearchPlaceholderLabel = 'Filter by purpose of visit',
      visitTypeAllLabel = 'All',
      visitTypeInPersonLabel = 'In Person',
      visitTypeVirtualLabel = 'Virtual Visit',
      visitTypePhoneLabel = 'Phone Visit',
      clearFiltersLabel = 'Clear filters',
      filterSummaryLabel = (count, total) => `Showing ${count} of ${total}`
    } = {},
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.ApptPurposeFilterContainer, props, /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.FilterControlsContainer, null, /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.SearchBox, {
    id: "appt-purpose-filter-search",
    name: "appt-purpose-filter-search",
    label: purposeSearchLabel,
    hideLabel: true,
    hideErrors: true,
    placeholder: purposeSearchPlaceholderLabel,
    maxLength: 25,
    value: nameFilterValue,
    onChange: onNameFilterChange ? e => {
      onNameFilterChange(e.target.value);
    } : undefined
  }), /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.FilterButtons, {
    "data-testid": "ApptPurposeFilter-VisitType",
    role: "group",
    type: "single",
    variant: "rounded",
    value: visitTypeFilterValue,
    onClick: onVisitTypeFilterChange ? (_, val) => {
      onVisitTypeFilterChange(val);
    } : undefined
  }, /*#__PURE__*/_react.default.createElement(_button.SegmentedButton, {
    value: _constants.ALL
  }, visitTypeAllLabel), /*#__PURE__*/_react.default.createElement(_button.SegmentedButton, {
    value: _constants.IN_PERSON
  }, visitTypeInPersonLabel), /*#__PURE__*/_react.default.createElement(_button.SegmentedButton, {
    value: _constants.VIDEO
  }, visitTypeVirtualLabel), /*#__PURE__*/_react.default.createElement(_button.SegmentedButton, {
    value: _constants.PHONE
  }, visitTypePhoneLabel))), /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.ClearFilterButton, {
    mode: "flat",
    disabled: !isFiltered,
    onClick: onClearFilters
  }, clearFiltersLabel), isFiltered ? /*#__PURE__*/_react.default.createElement(_ApptPurposeFilter.FilterSummary, null, filterSummaryLabel(count, total)) : null);
};
exports.ApptPurposeFilter = ApptPurposeFilter;
ApptPurposeFilter.propTypes = {
  /* The current number of purposes after filtering */
  count: _propTypes.PropTypes.number,
  /* The total number of purposes */
  total: _propTypes.PropTypes.number,
  /* Indicates whether the list is currently filtered */
  isFiltered: _propTypes.PropTypes.bool,
  /* Current Value of the name filter */
  nameFilterValue: _propTypes.PropTypes.string,
  /* Current Value of the visit type filter */
  visitTypeFilterValue: _propTypes.PropTypes.string,
  /* Render function for each appointment purpose */
  purposeRenderer: _propTypes.PropTypes.func,
  /* Internal key used for animation */
  animKey: _propTypes.PropTypes.string,
  /* Labels for rendering the filter controls */
  labels: _propTypes.PropTypes.shape({
    noResultsLabel: _propTypes.PropTypes.string,
    purposeSearchLabel: _propTypes.PropTypes.string,
    purposeSearchPlaceholderLabel: _propTypes.PropTypes.string,
    visitTypeAllLabel: _propTypes.PropTypes.string,
    visitTypeInPersonLabel: _propTypes.PropTypes.string,
    visitTypeVirtualLabel: _propTypes.PropTypes.string
  }),
  /* Function executed when the name filter changes */
  onNameFilterChange: _propTypes.PropTypes.func,
  /* Function executed when the visit type filter changes */
  onVisitTypeFilterChange: _propTypes.PropTypes.func,
  /* Function executed when the filters are cleared */
  onClearFilters: _propTypes.PropTypes.func
};
ApptPurposeFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptPurposeFilter",
  "props": {
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "noResultsLabel": {
            "name": "string",
            "required": false
          },
          "purposeSearchLabel": {
            "name": "string",
            "required": false
          },
          "purposeSearchPlaceholderLabel": {
            "name": "string",
            "required": false
          },
          "visitTypeAllLabel": {
            "name": "string",
            "required": false
          },
          "visitTypeInPersonLabel": {
            "name": "string",
            "required": false
          },
          "visitTypeVirtualLabel": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "count": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "total": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "isFiltered": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "nameFilterValue": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "visitTypeFilterValue": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "purposeRenderer": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "animKey": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onNameFilterChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onVisitTypeFilterChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onClearFilters": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};